import './Pills.scss';

export default function Pills({pills}) {
    return (
      <>
        <div className="pills">
          { pills.map((pill) => (
            <div className="pill">
              {pill}
            </div>
          ))}
        </div>
    </>
    );
  }